export const segmentVersionKey = 'segment_version';
